import SjUploadModal from './SjUploadModal'

SjUploadModal.install = function (Vue) {
  Vue.component(SjUploadModal.name, SjUploadModal)
}

export default SjUploadModal



// WEBPACK FOOTER //
// ./src/components/sj-upload-modal/index.js